module.exports = __webpack_public_path__ + "static/img/P7.05b4538.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mszj/P7.png
// module id = vTbY
// module chunks = 0